import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'documentIssuePurposePlaceholder',
  standalone: true
})
export class DocumentIssuePurposePlaceholderPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/zaswiadczenie-z-mpzp': {
        return 'Wpisz tu do czego jest niezbędne zaświadczenie z MPZP';
      }
      case '/zaswiadczenie-ze-studium': {
        return 'Wpisz tu do czego jest niezbędne zaświadczenie ze Studium';
      }
      default: {
        return 'Wpisz tu do czego niezbędny jest wypis i/wyrys';
      }
    }
  }

}
